import {IVOptionSetEndpoint} from "~/interfaces/vSelectInterfaces";

export default {
  // user options rely on having an organization
  computed: {
  },
  methods: {
    // relies on having a selected entry
    generateAccountRelationsJson(): object[] {
      const accountRelationsJson = [];
      let accountRelations = this.selectedObjectModelEntry.accountRelationsArray;

      accountRelations = accountRelations.filter(accountRelation => {
        return accountRelation.client_id &&
        accountRelation.published_relation_id &&
        (accountRelation.account_id || accountRelation.user_email)
      })

      for (let i = accountRelations.length - 1; i >= 0; i--) {
        const accountRelation = accountRelations[i];
        const accountRelationJson = {
          client_id: accountRelation.client_id,
          published_relation: accountRelation.published_relation_id,
          entry: accountRelation.entry_id,
          account: accountRelation.account_id,
          account_type: accountRelation.account_type,
        }

        if (accountRelation.user_email) {
          accountRelationJson["user_email"] = accountRelation.user_email.toLowerCase();
        }

        const alreadyHaveRelation = accountRelationsJson.find(json => {
          return json.published_relation === accountRelationJson.published_relation;
        })

        if (!alreadyHaveRelation) {
          accountRelationsJson.push(accountRelationJson);
        } else {
          delete this.selectedObjectModelEntry.account_relations[accountRelation.client_id];
        }
      }

      return accountRelationsJson;
    },
    userOptions(publishedObjectModelRelation): IVOptionSetEndpoint {
      return {
        valueKey: 'id',
        labelKey: user => `${user.first_name} ${user.last_name}`,
        endpoint: `/published_object_model_relations/${publishedObjectModelRelation.id}/search_users`,
        rootKey: 'users',
      }
    },
  }
}